import React from "react";
import { useTranslation } from "react-i18next";
import "~/css/ConversationEndExplanationModal.css";
import "~/css/Modal.css";
import "~/css/FontSize.css";
import * as icon from "~/Icons";

/**
 * 会話終了の仕組み説明モーダルのプロパティインターフェース
 */
interface ConversationEndExplanationModalProps {
  isOpen: boolean; // モーダル表示状態
  onClose: () => void; // 閉じるボタンクリック時のコールバック
}

/**
 * 会話終了のタイミング設定に関する説明モーダル
 * ユーザーの無音状態と会話終了までのフローを説明します
 */
const ConversationEndExplanationModal: React.FC<ConversationEndExplanationModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  // モーダルが非表示の場合は何も表示しない
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal-overlay">
        <div className="exp-modal">
          {/* モーダルヘッダー */}
          <div className="modal-header font-default-bold-24">
            <h2>{t("conversationEndTimingSetting")}</h2>
            <button className="modal-close-button" onClick={onClose} aria-label="閉じる">
              <icon.icons_close />
            </button>
          </div>

          {/* 説明コンテンツ */}
          <div className="exp-modal-content font-default-normal-20">
            <div>
              {t("userSilenceExplanationPart1")}
              <br />
              {t("userSilenceExplanationPart2")}
              <br />
              {t("userSilenceExplanationPart3")}
              <br />
              {t("userSilenceExplanationPart4")}
              <span className="highlight">{t("silenceDuration")}</span>
              {t("userSilenceExplanationPart5")}
            </div>
          </div>

          {/* プロセスフロー図 */}
          <div className="process-flow font-default-bold-24">
            <div className="step">
              <span>{t("conversationPossible")}</span>
            </div>

            <div className="arrow-container">
              <div className="circle"></div>
              <div className="line"></div>
            </div>

            <div className="step right-arrow">
              <span>{t("processingStart")}</span>
            </div>
          </div>

          <br />

          {/* 注意書き */}
          <div className="note font-default-normal-20">
            {t("standbyModeExplanation")}
            <br />
            <span className="highlight">{t("exampleSilenceDuration")}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConversationEndExplanationModal;
